define('model/TimeZoneModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Time zone model
     *
     * @class TimeZoneModel
     */
    return BaseModel.extend({

        defaults: {
            id: null,
            name: null,
            time_diff: 0,
            offset: 0
        },

        getCurrentDateTime: function () {
            var date = new Date();
            var utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);

            return new Date(utcTime + (this.get('offset') * 1000));
        },

        toJSON: function () {
            var result = BaseModel.prototype.toJSON.apply(this);
            result.current_date_time = this.getCurrentDateTime();

            return result;
        }

    });

});
